import React, { FC, useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { withProcedureWraper } from "../..";
import { getEnv } from "../../../../AppConfigs";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import FontFa from "../../../../components/fontFa/fontFa";
import { Icon } from "../../../../components/icon";
import { UserSelect } from "../../../../components/input/select/UserSelect";
import { CreateNotification } from "../../../../components/notifier";
import { approverType } from "../../../../constants/itCodeRequestConstants";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../constants/statusConstants";
import { getDDMMYYYFormat, getHHmmFormat, getUCTDate } from "../../../../helper/dateTimeHelper";
import { Button } from "../../../../modules/button";
import { Message } from "../../../../modules/message";
import { MailService } from "../../../../services/mail/mail.service";
import { useSelector } from "../../../../store/store";
import { BusinessTicketRequestService } from "../../../../services/company-office/BusinessTicketService";
import CommentSection from "../../info-technology-process/commentsection/comment-sections";
import { InputWraper, useForm } from "../../../../modules/form";
import { InputArrayData } from "../../../../components/input";
import { PassportContentForm, PassportContentStructure } from "./formBusinessTicket";
import { FileAttachmentCard } from "../../upload";
import { eApprovalChangeOptions } from "../companyRequestContants/companyRequestContants";
import _ from "lodash";
import { PinLayout } from "../../components/layout/PinsLayout";
import { ProcessContextProvider, ProcessContextType } from "../../process-context";
import { useQueryClient } from "@tanstack/react-query";
import { Col, Row } from "antd";
import BoxSectionItem from "../../../../components/box-section/box-section-item";

const siteUrl = getEnv("REACT_APP_APPROVER_BUSINESS_TICKET_REQUEST_URL");

export const businessTicketDetail: FC = withProcedureWraper(() => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;
  const history = useHistory();
  const [officialBusinessTicketRequest, setOfficialBusinessTicketRequest] = useState(null as any);
  const { id } = useRouteMatch().params as any;
  const [comment, setComment] = useState("" as string);
  const [approvalType, setApprovalType] = useState(0);
  const [approvalStep, setApprovalStep] = useState(approverType.approver);
  const [pickedItHead, setPickedItHead] = useState(null as any);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  // const userExport = [
  //   "canbo1@viags.vn",
  //   "botit@viags.vn",
  //   "canbo2@viags.vn",
  //   "thiennv@viags.vn",
  //   "huongptt@viags.vn",
  //   "huongdtt@viags.vn",
  //   "anhttt@viags.vn",
  //   "hieptd@viags.vn",
  // ];
  const queryClient = useQueryClient();

  const { getInputProps } = useForm({
    structure: [
      {
        name: "passport2",
        label: "Giấy đi đường",
        defaultValue: [],
      },
    ],
    onSubmit: () => {},
  });

  const [passport, setPassport] = useState<any>(
    getInputProps("passport2").value.length !== 0 ? getInputProps("passport2").value : [],
  );

  const sendMail = async (status: string, rejectComment?: any) => {
    const { fields } = officialBusinessTicketRequest;
    const url = siteUrl + "/details/" + officialBusinessTicketRequest.id;
    let template = mailtemplates.find((m: any) => m.eMailType === "BTRA");
    let content = template.eContent;
    let subject = template.eSubject;
    let arrApprover = fields.eApprovedByITLead.split("|");
    let name = officialBusinessTicketRequest.createdBy.user.displayName;
    let tomail = officialBusinessTicketRequest.createdBy.user.email;
    let doing = "duyệt";
    if (status === requestStatus.rejected) {
      template = mailtemplates.find((m: any) => m.eMailType === "BTRR");
      content = template.eContent
        .replace(mailRegexs.zero + ";", name)
        .replace(mailRegexs.one + ";", rejectComment?.value ? `${rejectComment?.value} (${rejectComment?.date})` : "")
        .replace(mailRegexs.siteUrl, url);
      subject = template.eSubject;

      if (approvalStep === approverType.ithead) {
        tomail = fields.eApprovedByITHead.split("|")[0];
        content = template.eContent
          .replace(mailRegexs.zero + ";", fields.eApprovedByITLead.split("|")[1])
          .replace(mailRegexs.one + ";", rejectComment?.value ? `${rejectComment?.value} (${rejectComment?.date})` : "")
          .replace(mailRegexs.siteUrl, url);
      }
      tomail = arrApprover.length > 0 ? arrApprover[0] : "";
      if (approvalStep === approverType.assignee) {
        tomail = officialBusinessTicketRequest.createdBy.user.email;
      }
      if (approvalStep === approverType.approver) {
        tomail = officialBusinessTicketRequest.createdBy.user.email;
      }
      if (approvalStep === approverType.itlead) {
        tomail = fields.eApprovedBy.split("|")[0];
        content = template.eContent
          .replace(mailRegexs.zero + ";", fields.eApprovedBy.split("|")[1])
          .replace(mailRegexs.one + ";", rejectComment?.value ? `${rejectComment?.value} (${rejectComment?.date})` : "")
          .replace(mailRegexs.siteUrl, url);
        const message = MailService.buildMailMesssage(subject, content, "html", tomail);
        await MailService.sendMail(message);
        tomail = officialBusinessTicketRequest.createdBy.user.email;
      }
    } else if (approvalStep === approverType.assignee) {
      template = mailtemplates.find((m: any) => m.eMailType === "BTRF");
      tomail = officialBusinessTicketRequest.createdBy.user.email;
      name = officialBusinessTicketRequest.createdBy.user.displayName;
      content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.one, comment || "");
      subject = template.eSubject;
    } else {
      if (approvalType === approverType.approver) {
        arrApprover = fields.eApprovedByITLead.split("|");
      }
      if (approvalType === approverType.itlead) {
        arrApprover = fields.eApprovedByITHead.split("|");
      }
      if (approvalType === approverType.ithead) {
        arrApprover = fields.eAssignee.split("|");
        doing = "thực hiện";
      }
      tomail = arrApprover.length > 0 ? arrApprover[0] : "";
      name = arrApprover.length > 1 ? arrApprover[1] : "";
      content = template.eContent
        .replace(mailRegexs.zero + ";", name)
        .replace(mailRegexs.one + ";", doing)
        .replace(mailRegexs.two + ";", officialBusinessTicketRequest.createdBy.user.displayName)
        .replace(
          mailRegexs.three + ";",
          `${getDDMMYYYFormat(officialBusinessTicketRequest.createdDateTime)} - ${getHHmmFormat(
            officialBusinessTicketRequest.createdDateTime,
          )}`,
        )
        .replace(mailRegexs.siteUrl, url);
      // if (approvalType === approverType.itlead) {
      //   const message = MailService.buildMailMesssage(subject, content, 'html', 'it@viags.vn');
      //   const res = await MailService.sendMail(message);
      // }
    }

    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const approveRequest = () => {
    const { fields } = officialBusinessTicketRequest;
    const dateApprove = getUCTDate();
    const approveComment = {
      type: "approve",
      value: comment || "",
      date: `${getDDMMYYYFormat(dateApprove)} ${getHHmmFormat(dateApprove)}`,
    };
    switch (approvalType) {
      case approverType.approver:
        const arrComment = fields.eDeptHeadComment ? JSON.parse(fields.eDeptHeadComment) : [];
        const approverComment = [...arrComment];
        approverComment.push(approveComment);
        fields.eDeptHeadComment = JSON.stringify(approverComment);
        fields.eApprovedStatus = requestStatus.approved;
        fields.eApprovedDate = dateApprove;
        // if (pickedItHead) {
        //   const itLeadTmp = employees.find((f: any) => f.eMail === pickedItHead);
        //   fields.eApprovedByITLead =  `${itLeadTmp.eMail}|${itLeadTmp.Title}`;
        // }
        break;
      case approverType.itlead:
        if (passport.length <= 0) {
          CreateNotification({
            title: "Đồng ý thất bại",
            body: `Vui lòng thêm giấy đi đường`,
            icon: "/icons/warning.png",
          });
          return;
        }
        const arrITLeadComment = fields.eITLeadComment ? JSON.parse(fields.eITLeadComment) : [];
        const itLeadComment = [...arrITLeadComment];
        itLeadComment.push(approveComment);
        fields.eITLeadComment = JSON.stringify(itLeadComment);
        fields.eApprovedByITLeadStatus = requestStatus.approved;
        fields.eApprovedByITLeadDate = dateApprove;
        fields.ePassportContent = JSON.stringify(passport);
        if (pickedItHead) {
          fields.eApprovedByITHead = `${pickedItHead.value}|${pickedItHead.label}`;
          const newPassport = passport.map((item: any) => ({
            ...item,
            ITHead: `${pickedItHead.value}|${pickedItHead.label}`,
          }));
          setPassport(newPassport);
          fields.ePassportContent = JSON.stringify(newPassport);
        }
        // if (employeesSelected) {
        //   const assignee = employees.find(
        //     (v: any) =>
        //       v.eMail.toLowerCase() === employeesSelected.toLowerCase()
        //   );
        //   if (assignee) {
        //     fields.eAssignee = `${assignee.eMail}|${assignee.Title}`;
        //   }
        // }
        break;
      case approverType.ithead:
        const arrITHeadComment = fields.eITHeadComment ? JSON.parse(fields.eITHeadComment) : [];
        const itHeadComment = [...arrITHeadComment];
        itHeadComment.push(approveComment);
        fields.eITHeadComment = JSON.stringify(itHeadComment);
        fields.eApprovedByITHeadStatus = requestStatus.approved;
        fields.eApprovedByITHeadDate = dateApprove;
        fields.eRequestStatus = requestStatus.inProgress;
        break;
      case approverType.assignee:
        const arrAssignedComment = fields.eAssigneeComment ? JSON.parse(fields.eAssigneeComment) : [];
        const assignedComment = [...arrAssignedComment];
        assignedComment.push(approveComment);
        fields.eAssigneeComment = JSON.stringify(assignedComment);
        fields.eAssigneeStatus = requestStatus.approved;
        fields.eAssigneeStatusDate = dateApprove;
        fields.eRequestStatus = requestStatus.completed;
        break;
      default:
        break;
    }

    BusinessTicketRequestService.updateBusinessTicketRequest(officialBusinessTicketRequest.id, fields)
      .then((res) => {
        CreateNotification({
          title: "Thành công",
          body: `Đã duyệt thành công.`,
          icon: "/icons/success.png",
        });
        sendMail(requestStatus.approved);
        history.push(Routes.procedureCollaborateTicket.path);
      })
      .catch((err) => {
        CreateNotification({
          title: "Thất bại",
          body: `Đã duyệt thất bại.`,
          icon: "/icons/error.png",
        });
      });
  };

  const recoverRequest = () => {
    const { fields } = officialBusinessTicketRequest;
    switch (approvalType) {
      case approverType.approver:
        fields.eDeptHeadComment = "";
        fields.eApprovedStatus = "";
        fields.eApprovedDate = null;
        break;
      case approverType.itlead:
        fields.eDeptHeadComment = "";
        fields.eApprovedByITLeadStatus = "";
        fields.eApprovedByITLeadDate = null;
        break;
      case approverType.ithead:
        fields.eITHeadComment = "";
        fields.eApprovedByITHeadStatus = "";
        fields.eApprovedByITHeadDate = null;
        fields.eRequestStatus = requestStatus.submitted;
        break;
      case approverType.assignee:
        fields.eAssigneeComment = "";
        fields.eAssigneeStatus = "";
        fields.eAssigneeStatusDate = null;
        fields.eRequestStatus = requestStatus.submitted;
        break;
      default:
        break;
    }
    BusinessTicketRequestService.updateBusinessTicketRequest(officialBusinessTicketRequest.id, fields)
      .then((res) => {
        CreateNotification({
          title: "Thành công",
          body: `Thu hồi thành công.`,
          icon: "/icons/success.png",
        });
        sendMail(requestStatus.approved);
        history.push(Routes.procedureCollaborateTicket.path);
      })
      .catch((err) => {
        CreateNotification({
          title: "Thất bại",
          body: `Thu hồi thất bại.`,
          icon: "/icons/error.png",
        });
      });
  };

  const rejectRequest = () => {
    const { fields } = officialBusinessTicketRequest;
    // fields.eRequestStatus = requestStatus.rejected;
    const dateReject = getUCTDate();

    if (!comment) {
      CreateNotification({
        title: "Thông báo",
        body: "Anh Chị vui lòng nhập lưu ý khi từ chối phê duyệt vào ô phía trên !",
        icon: "/icons/warning.png",
      });
      return;
    }
    const rejectComment = {
      type: "reject",
      value: comment,
      date: `${getDDMMYYYFormat(dateReject)} ${getHHmmFormat(dateReject)}`,
    };
    switch (approvalType) {
      case approverType.approver:
        const arrComment = fields.eDeptHeadComment ? JSON.parse(fields.eDeptHeadComment) : [];
        const approverComment = [...arrComment];
        approverComment.push(rejectComment);
        fields.eDeptHeadComment = JSON.stringify(approverComment);
        break;
      case approverType.itlead:
        const arrCommentITLead = fields.eITLeadComment ? JSON.parse(fields.eITLeadComment) : [];
        const approverCommentITLead = [...arrCommentITLead];
        approverCommentITLead.push(rejectComment);
        fields.eITLeadComment = JSON.stringify(approverCommentITLead);
        fields.eApprovedStatus = null;
        fields.eApprovedDate = null;
        break;
      case approverType.ithead:
        const arrCommentITHead = fields.eITHeadComment ? JSON.parse(fields.eITHeadComment) : [];
        const approverCommentITHead = [...arrCommentITHead];
        approverCommentITHead.push(rejectComment);
        fields.eITHeadComment = JSON.stringify(approverCommentITHead);
        fields.eApprovedByITLeadStatus = null;
        fields.eApprovedByITLeadDate = null;
        break;
      case approverType.assignee:
        const arrCommentAssigned = fields.eAssigneeComment ? JSON.parse(fields.eAssigneeComment) : [];
        const approverCommentAssigned = [...arrCommentAssigned];
        approverCommentAssigned.push(rejectComment);
        fields.eAssigneeComment = JSON.stringify(approverCommentAssigned);
        fields.eAssigneeStatus = requestStatus.rejected;
        fields.eAssigneeStatusDate = dateReject;
        fields.eRequestStatus = requestStatus.rejected;
        break;
      default:
        break;
    }

    BusinessTicketRequestService.updateBusinessTicketRequest(officialBusinessTicketRequest.id, fields)
      .then((res) => {
        CreateNotification({
          title: "Thành công",
          body: `Từ chối thành công.`,
          icon: "/icons/success.png",
        });
        sendMail(requestStatus.rejected, rejectComment);
        history.push(Routes.procedureCollaborateTicket.path);
      })
      .catch((err) => {
        CreateNotification({
          title: "Thất bại",
          body: `Từ chối thất bại.`,
          icon: "/icons/error.png",
        });
      });
  };

  const cancelRequest = () => {
    const { fields } = officialBusinessTicketRequest;
    // fields.eRequestStatus = requestStatus.rejected;
    const dateReject = getUCTDate();

    if (!comment) {
      CreateNotification({
        title: "Thông báo",
        body: "Anh Chị vui lòng nhập lưu ý khi hủy phiếu vào ô phía trên !",
        icon: "/icons/warning.png",
      });
      return;
    }
    const rejectComment = {
      type: "reject",
      value: comment,
      date: `${getDDMMYYYFormat(dateReject)} ${getHHmmFormat(dateReject)}`,
    };
    switch (approvalType) {
      case approverType.approver:
        const arrComment = fields.eDeptHeadComment ? JSON.parse(fields.eDeptHeadComment) : [];
        const approverComment = [...arrComment];
        approverComment.push(rejectComment);
        fields.eApprovedStatus = requestStatus.rejected;
        fields.eApprovedDate = dateReject;
        fields.eDeptHeadComment = JSON.stringify(approverComment);
        fields.eRequestStatus = requestStatus.rejected;
        break;
      case approverType.itlead:
        const arrCommentITLead = fields.eITLeadComment ? JSON.parse(fields.eITLeadComment) : [];
        const approverCommentITLead = [...arrCommentITLead];
        approverCommentITLead.push(rejectComment);
        fields.eITLeadComment = JSON.stringify(approverCommentITLead);
        fields.eApprovedByITLeadStatus = requestStatus.rejected;
        fields.eApprovedByITLeadDate = dateReject;
        fields.eRequestStatus = requestStatus.rejected;
        break;
      case approverType.ithead:
        const arrCommentITHead = fields.eITHeadComment ? JSON.parse(fields.eITHeadComment) : [];
        const approverCommentITHead = [...arrCommentITHead];
        approverCommentITHead.push(rejectComment);
        fields.eITHeadComment = JSON.stringify(approverCommentITHead);
        fields.eApprovedByITHeadStatus = requestStatus.rejected;
        fields.eApprovedByITHeadDate = dateReject;
        fields.eRequestStatus = requestStatus.rejected;
        break;
      case approverType.assignee:
        const arrCommentAssigned = fields.eAssigneeComment ? JSON.parse(fields.eAssigneeComment) : [];
        const approverCommentAssigned = [...arrCommentAssigned];
        approverCommentAssigned.push(rejectComment);
        fields.eAssigneeComment = JSON.stringify(approverCommentAssigned);
        fields.eAssigneeStatus = requestStatus.rejected;
        fields.eAssigneeStatusDate = dateReject;
        fields.eRequestStatus = requestStatus.rejected;
        break;
      default:
        break;
    }

    BusinessTicketRequestService.updateBusinessTicketRequest(officialBusinessTicketRequest.id, fields)
      .then((res) => {
        CreateNotification({
          title: "Thành công",
          body: `Từ chối thành công.`,
          icon: "/icons/success.png",
        });
        sendMail(requestStatus.rejected, rejectComment);
        history.push(Routes.procedureCollaborateTicket.path);
      })
      .catch((err) => {
        CreateNotification({
          title: "Thất bại",
          body: `Từ chối thất bại.`,
          icon: "/icons/error.png",
        });
      });
  };

  const checkApproverType = () => {
    const {
      eApprovedBy,
      eApprovedByITLead,
      eApprovedByITHead,
      eAssignee,
      eApprovedStatus,
      eApprovedByITLeadStatus,
      eApprovedByITHeadStatus,
      eAssigneeStatus,
    } = officialBusinessTicketRequest.fields;
    const approverEmail = eApprovedBy ? eApprovedBy.split("|")[0] : "";
    const approvedByITLeadEmail = eApprovedByITLead ? eApprovedByITLead.split("|")[0] : "";
    const approvedByITHeadEmail = eApprovedByITHead ? eApprovedByITHead.split("|")[0] : "";
    const assigneeEmail = eAssignee ? eAssignee.split("|")[0] : "";
    if (currentUserName.toLowerCase() === approverEmail.toLowerCase() && !eApprovedStatus) {
      setApprovalType(approverType.approver);
    } else if (currentUserName.toLowerCase() === approvedByITLeadEmail.toLowerCase() && !eApprovedByITLeadStatus) {
      setApprovalType(approverType.itlead);
    } else if (currentUserName.toLowerCase() === approvedByITHeadEmail.toLowerCase() && !eApprovedByITHeadStatus) {
      setApprovalType(approverType.ithead);
    } else if (currentUserName.toLowerCase() === assigneeEmail.toLowerCase() && !eAssigneeStatus) {
      setApprovalType(approverType.assignee);
    }
  };

  const checkApproverStep = () => {
    const { eApprovedStatus, eApprovedByITLeadStatus, eApprovedByITHeadStatus, eAssigneeStatus } =
      officialBusinessTicketRequest.fields;
    if (!eApprovedStatus) {
      setApprovalStep(approverType.approver);
    } else if (!eApprovedByITLeadStatus) {
      setApprovalStep(approverType.itlead);
    } else if (!eApprovedByITHeadStatus) {
      setApprovalStep(approverType.ithead);
    } else if (!eAssigneeStatus) {
      setApprovalStep(approverType.assignee);
    }
  };

  const checkEdit = () => {
    return (
      // !officialBusinessTicketRequest.fields.eApprovedStatus &&
      !officialBusinessTicketRequest.fields.eApprovedByITLeadStatus &&
      !officialBusinessTicketRequest.fields.eApprovedByITHeadStatus &&
      !officialBusinessTicketRequest.fields.eAssigneeStatus
    );
  };

  const checkApproval = () => {
    if (officialBusinessTicketRequest) {
      const { eApprovedByITLeadStatus, eApprovedByITHeadStatus, eAssigneeStatus, eRequestStatus } =
        officialBusinessTicketRequest?.fields;
      if (eRequestStatus === requestStatus.rejected || eRequestStatus === requestStatus.completed) {
        return false;
      } else {
        if (approvalStep === approvalType) {
          return true;
        } else {
          if (approvalStep - approvalType === 1) {
            switch (approvalStep) {
              case approverType.itlead:
                return !eApprovedByITLeadStatus;
              case approverType.ithead:
                return !eApprovedByITHeadStatus;
              case approverType.assignee:
                return !eAssigneeStatus;
              default:
                return false;
            }
          } else return false;
        }
      }
    }
  };

  const handlePassportChange = (e: any) => {
    setPassport(e);
  };

  const onApproverChange = (selectedOptions: any) => {
    setPickedItHead(selectedOptions ? selectedOptions : "");
  };

  const getStepClassByStatus = (date: any, status: any) => {
    if (date) {
      return status === requestStatus.approved ? "approved" : "rejected";
    } else {
      return "waiting";
    }
  };

  const getStepIconByStatus = (status: any) => {
    switch (status) {
      case requestStatus.approved:
        return "faCheck";
      case requestStatus.rejected:
        return "faBan";
      default:
        return "";
    }
  };

  const getButtonText = () => {
    // eslint-disable-next-line eqeqeq
    if (approvalStep === approvalType && approvalStep == approverType.assignee) {
      return "Hoàn thành";
    } else {
      return "Đồng ý";
    }
  };

  const getTicketType = (ticketType: string) => {
    return ticketType === "full"
      ? "Cấp vé và giấy đi đường"
      : ticketType === "ticket"
      ? "Chỉ cấp vé công tác"
      : ticketType === "refund"
      ? "Hoàn vé"
      : "Chỉ cấp giấy đi đường";
  };

  const handleUpdatePin = useCallback(
    async (isPin: boolean) => {
      try {
        if (!officialBusinessTicketRequest) return;
        const pins: any[] = officialBusinessTicketRequest.fields.ePins
          ? JSON.parse(officialBusinessTicketRequest.fields.ePins)
          : [];
        const index = pins.findIndex((pin: string) => pin === currentUserName?.toLowerCase());
        if (!isPin && index < 0) return;
        if (isPin && index > -1) return;
        if (!isPin && index > -1) pins.splice(index, 1);
        if (isPin && index < 0) pins.push(currentUserName?.toLowerCase());

        const fields = {
          ePins: JSON.stringify(pins),
        };

        await BusinessTicketRequestService.updateBusinessTicketRequest(id, fields);
        queryClient.invalidateQueries({ queryKey: ["business-tickets-requests"] });
      } catch (error) {
        console.log(error);
      }
    },
    [currentUserName, id, officialBusinessTicketRequest, queryClient],
  );

  const isPin = useCallback(() => {
    if (!officialBusinessTicketRequest) return false;
    const pins: any[] = officialBusinessTicketRequest.fields.ePins
      ? JSON.parse(officialBusinessTicketRequest.fields.ePins)
      : [];
    return pins.findIndex((pin: string) => pin === currentUserName?.toLowerCase()) >= 0;
  }, [currentUserName, officialBusinessTicketRequest]);

  const ctx = useMemo<ProcessContextType<any>>(
    () => ({
      Request: officialBusinessTicketRequest,
      updatePin: handleUpdatePin,
      isPin: isPin,
    }),
    [handleUpdatePin, isPin, officialBusinessTicketRequest],
  );

  useEffect(() => {
    BusinessTicketRequestService.getBusinessTicketRequest(id)
      .then((res) => {
        setOfficialBusinessTicketRequest(res);
        if (res.fields) {
          // setComment(res.fields.eApprovalComments);
          if (res?.fields?.ePassportContent) {
            setPassport(JSON.parse(res.fields.ePassportContent));
          } else {
            const travelTicket = res?.fields?.eContent ? JSON.parse(res.fields.eContent) : [];
            const newTravelTicket = travelTicket.map((e: any, index: number) => {
              const tripArray = _.cloneDeep(e.TripBusiness) || [];
              const modifiedTripArray = tripArray.map((obj: any) => ({ ...obj, to: "" }));
              return {
                id: index + 2,
                PassportForPerson: e.Name,
                Position: e.Position,
                Unit: res?.fields.eUnit || "",
                SendOnForBusiness: res?.fields.eOffice || "",
                BusinessTime:
                  getDDMMYYYFormat(new Date(res?.fields?.eWorkingTime)) +
                  " - " +
                  getDDMMYYYFormat(new Date(res?.fields?.eFinishTime)),
                TripBusiness: modifiedTripArray,
                Trip: e.TripBusiness,
                Class: e.Class || "",
                TickNumber: e.TickNumber || "",
                // BusinessUnit: res?.fields.eOffice || '',
                BusinessContent: res?.fields.eDescription || "",
                ConfirmBusinessUnit: "",
                ITHead: res?.fields?.eApprovedByITHead,
                eBaseOnDecision: res?.fields?.eBaseOnDecision,
              };
            });
            setPassport(newTravelTicket);
          }
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, [id]);

  const handleGoBack = () => {
    if (history.action === "PUSH") history.goBack();
    else history.push(Routes.procedureCollaborateTicket.path);
  };

  useEffect(() => {
    if (officialBusinessTicketRequest) {
      checkApproverType();
      checkApproverStep();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [officialBusinessTicketRequest]);

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={handleGoBack}>
            <Icon.ArrowLeft />
          </div>
          {"Xem Xét Duyệt 2"}
        </div>
      </div>

      {(() => {
        if (!officialBusinessTicketRequest) return <Message type="loading" />;
        if (officialBusinessTicketRequest.errorMessage)
          return <Message type="error" message={officialBusinessTicketRequest.errorMessage} />;

        const { fields, createdDateTime } = officialBusinessTicketRequest;
        const {
          // eSoftwareId,
          // eStaff,
          // eReason,
          eContent,
          eDeptHeadComment,
          eITLeadComment,
          eITHeadComment,
          eAssigneeComment,
          eApprovedStatus,
          eApprovedByITLeadStatus,
          eAssigneeStatusDate,
          eApprovedByITHeadStatus,
          eApprovedBy,
          eApprovedDate,
          eApprovedByITLead,
          eApprovedByITLeadDate,
          eApprovedByITHead,
          eApprovedByITHeadDate,
          eAssignee,
          eAssigneeStatus,
          eBaseOnProposal,
          eTicketType,
        } = fields;
        const contentData = JSON.parse(eContent);
        const eDeptHeadCommentData = eDeptHeadComment ? JSON.parse(eDeptHeadComment) : [];
        const eITLeadCommentData = eITLeadComment ? JSON.parse(eITLeadComment) : [];
        const eITHeadCommentData = eITHeadComment ? JSON.parse(eITHeadComment) : [];
        const eAssigneeCommentData = eAssigneeComment ? JSON.parse(eAssigneeComment) : [];
        const eBaseOnProposalFileUrl = eBaseOnProposal ? JSON.parse(eBaseOnProposal) : [];
        return (
          <>
            <div className="col-lg-12 col-md-12">
              <div>
                <ProcessContextProvider context={ctx} isHideUI={true}>
                  <Box
                    title={
                      <span>
                        Quy trình duyệt - yêu cầu {officialBusinessTicketRequest.id} <PinLayout />
                      </span>
                    }
                  >
                    <div className="TimelineBox horizontal">
                      <div className="item">
                        <div className="step approved">
                          <FontFa name="faCheck" />
                        </div>
                        <div className="content">
                          <div className="rank">
                            <h6>Khởi tạo</h6>
                          </div>
                          <div className="title">{officialBusinessTicketRequest.createdBy.user.displayName}</div>
                          <div className="title">{officialBusinessTicketRequest.createdBy.user.email}</div>
                          <div className="time">{`Ngày tạo: ${getDDMMYYYFormat(createdDateTime)} - ${getHHmmFormat(
                            createdDateTime,
                          )}`}</div>
                        </div>
                      </div>
                      {eApprovedBy && (
                        <div className="item">
                          <div className={`step ${getStepClassByStatus(eApprovedDate, eApprovedStatus)}`}>
                            <FontFa name={getStepIconByStatus(eApprovedStatus)} />
                          </div>
                          <div className="content">
                            <div className="rank">
                              <h6>Thủ trưởng CQ/ĐV</h6>
                            </div>
                            <div className="title">{eApprovedBy.split("|")[1]}</div>
                            <div className="title">{eApprovedBy.split("|")[0]}</div>
                            <div className="time">
                              {eApprovedDate ? (
                                `Ngày duyệt: ${getDDMMYYYFormat(eApprovedDate)} - ${getHHmmFormat(eApprovedDate)}`
                              ) : (
                                <span className="flag default">{"Chưa duyệt"}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {eApprovedByITLead && (
                        <div className="item">
                          <div
                            className={`step ${getStepClassByStatus(eApprovedByITLeadDate, eApprovedByITLeadStatus)}`}
                          >
                            <FontFa name={getStepIconByStatus(eApprovedByITLeadStatus)} />
                          </div>
                          <div className="content">
                            <div className="rank">
                              <h6>Bộ phận hành chính VPCT</h6>
                            </div>
                            <div className="title">{eApprovedByITLead.split("|")[1]}</div>
                            <div className="title">{eApprovedByITLead.split("|")[0]}</div>
                            <div className="time">
                              {eApprovedByITLeadDate ? (
                                `Ngày duyệt: ${getDDMMYYYFormat(eApprovedByITLeadDate)} - ${getHHmmFormat(
                                  eApprovedByITLeadDate,
                                )}`
                              ) : (
                                <span className="flag default">{"Chưa duyệt"}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {eApprovedByITHead && (
                        <div className="item">
                          <div
                            className={`step ${getStepClassByStatus(eApprovedByITHeadDate, eApprovedByITHeadStatus)}`}
                          >
                            <FontFa name={getStepIconByStatus(eApprovedByITHeadStatus)} />
                          </div>
                          <div className="content">
                            <div className="rank">
                              <h6>Cán Bộ VPCT</h6>
                            </div>
                            <div className="title">{eApprovedByITHead.split("|")[1]}</div>
                            <div className="title">{eApprovedByITHead.split("|")[0]}</div>
                            <div className="time">
                              {eApprovedByITHeadDate ? (
                                `Ngày duyệt: ${getDDMMYYYFormat(eApprovedByITHeadDate)} - ${getHHmmFormat(
                                  eApprovedByITHeadDate,
                                )}`
                              ) : (
                                <span className="flag default">{"Chưa duyệt"}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {eAssignee && (
                        <div className="item">
                          <div className={`step ${getStepClassByStatus(eAssigneeStatusDate, eAssigneeStatus)}`}>
                            <FontFa name={getStepIconByStatus(eAssigneeStatus)} />
                          </div>
                          <div className="content">
                            <div className="rank">
                              <h6>Thực hiện cấp/hoàn vé</h6>
                            </div>
                            <div className="title">{eAssignee.split("|")[1]}</div>
                            <div className="title">{eAssignee.split("|")[0]}</div>
                            <div className="time">
                              {eAssigneeStatusDate &&
                                `Ngày thực hiện: ${getDDMMYYYFormat(eAssigneeStatusDate)} - ${getHHmmFormat(
                                  eAssigneeStatusDate,
                                )}`}
                              {eAssigneeStatus === requestStatus.submitted && (
                                <span className="flag default">{"Chưa thực hiện yêu cầu"}</span>
                              )}
                              {eAssigneeStatus === requestStatus.inProgress && (
                                <span className="flag info">{"Đang thực thi"}</span>
                              )}
                              {eAssigneeStatus === requestStatus.rejected && (
                                <span className="flag danger">{"Đã từ chối"}</span>
                              )}
                              {eAssigneeStatus === requestStatus.completed && (
                                <span className="flag success">{"Đã thực hiện yêu cầu"}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </Box>
                </ProcessContextProvider>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 mb-4">
              <Box title="Thông tin cấp/hoàn vé công tác" className="full-height box__detail-container">
                <div className="TableInformation">
                  <Row gutter={[32, 0]}>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem textLeft="Nhu cầu" textRight={getTicketType(eTicketType)} />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="Người yêu cầu:"
                        textRight={officialBusinessTicketRequest.createdBy.user.displayName}
                      />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="SĐT Người yêu cầu:"
                        textRight={officialBusinessTicketRequest.fields.ePhoneNumber}
                      />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="Cơ quan/Đơn vị:"
                        textRight={officialBusinessTicketRequest.fields.eDepartment}
                      />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem textLeft="Đơn vị:" textRight={officialBusinessTicketRequest.fields.eUnit} />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="Nội dung: "
                        textRight={officialBusinessTicketRequest.fields.eDescription}
                      />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="Căn cứ theo quyết định:"
                        textRight={officialBusinessTicketRequest.fields.eBaseOnDecision || ""}
                      />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="Căn cứ theo tờ trình:"
                        textRight={
                          <span>
                            <FileAttachmentCard listFile={eBaseOnProposalFileUrl}></FileAttachmentCard>
                          </span>
                        }
                      />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="Thời gian bắt đầu: "
                        textRight={getDDMMYYYFormat(officialBusinessTicketRequest.fields.eWorkingTime)}
                      />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="Thời gian kết thúc: "
                        textRight={getDDMMYYYFormat(officialBusinessTicketRequest.fields.eFinishTime)}
                      />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem textLeft="Hành trình:" textRight={officialBusinessTicketRequest.fields.eTrip} />
                    </Col>
                  </Row>
                  <table>
                    <tbody>
                      <td className="py-2 text-uppercase font-weight-bold">Chi tiết</td>
                      <tr>
                        <Row>
                          <td colSpan={4}>
                            <div className="detailTable">
                              <table className="table table-striped ">
                                <thead>
                                  <tr>
                                    <th>Họ và tên</th>
                                    <th>Chức danh</th>
                                    <th>Hạng vé</th>
                                    <th>Số vé</th>
                                    <th>Hành trình</th>
                                    {/* <th>Chuyến bay đi / giờ / ngày</th>
                                  <th>Chuyến bay về / giờ / ngày</th> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {contentData.map((item: any, key: any) => {
                                    return (
                                      <tr key={key}>
                                        <td>{item.Name}</td>
                                        <td>{item.Position}</td>
                                        <td>{item.Class}</td>
                                        <td>{item.TickNumber}</td>
                                        <td>
                                          {item.TripBusiness.map((e: any) => (
                                            <div>{`${e.from} - ${e.to} (${getDDMMYYYFormat(e.date)} ${getHHmmFormat(
                                              e.date,
                                            )})`}</div>
                                          ))}
                                        </td>
                                        {/* <td>{item.FlightAway}</td>
                                      <td>{item.ReturnFlight}</td> */}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </Row>
                      </tr>
                      <tr>
                        <td colSpan={4}>
                          <InputWraper
                            isRequired
                            inputProps={getInputProps("passport2")}
                            renderInput={(state) => (
                              <InputArrayData
                                {...state}
                                form={PassportContentForm}
                                value={passport.length > 0 ? passport : null}
                                onChange={handlePassportChange}
                                isTrip={true}
                                structure={PassportContentStructure}
                                isDisabled={true}
                                exportPassport={true}
                                // isDisabled={approvalStep === approverType.itlead &&  eApprovedByITLead.split("|")[0] === currentUserName.toLowerCase() ? false : true}
                                isDisableEdit={
                                  approvalStep === approverType.itlead &&
                                  eApprovedByITLead.split("|")[0] === currentUserName.toLowerCase()
                                    ? false
                                    : true
                                }
                              />
                            )}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="mt-2 d-flex flex-column">
                  Tệp đính kèm
                  <FileAttachmentCard
                    listFile={
                      officialBusinessTicketRequest.fields.eFileContent
                        ? JSON.parse(officialBusinessTicketRequest.fields.eFileContent)
                        : []
                    }
                  />
                </div>
                <td className="pb-1 pt-4 text-uppercase font-weight-bold">Lịch sử phê duyệt</td>
                <div className="InputWraper">
                  <div className="wraper">
                    <>
                      {eDeptHeadComment &&
                        eDeptHeadCommentData.map((e: any) => {
                          return e.type === "reject" ? (
                            <div className="py-2 pl-3">
                              <p>
                                <span className="font-weight-bold">Thủ trưởng CQ/ĐV, {eApprovedBy.split("|")[1]}</span>{" "}
                                đã từ chối với lý do: {e.value} ({e.date})
                              </p>
                            </div>
                          ) : (
                            <div className="py-2 pl-3">
                              <p>
                                <span className="font-weight-bold">Thủ trưởng CQ/ĐV, {eApprovedBy.split("|")[1]}</span>{" "}
                                đã phê duyệt, lưu ý: {e.value} ({e.date})
                              </p>
                            </div>
                          );
                        })}
                      {eITLeadComment &&
                        eITLeadCommentData.map((e: any) => {
                          return e.type === "reject" ? (
                            <div className="py-2 pl-3">
                              <p>
                                <span className="font-weight-bold">
                                  Bộ phận hành chính VPCT, {eApprovedByITLead.split("|")[1]}
                                </span>{" "}
                                đã từ chối với lý do: {e.value} ({e.date})
                              </p>
                            </div>
                          ) : (
                            <div className="py-2 pl-3">
                              <p>
                                <span className="font-weight-bold">
                                  Bộ phận hành chính VPCT, {eApprovedByITLead.split("|")[1]}
                                </span>{" "}
                                đã phê duyệt, lưu ý: {e.value} ({e.date})
                              </p>
                            </div>
                          );
                        })}
                      {eITHeadComment &&
                        eITHeadCommentData.map((e: any) => {
                          return e.type === "reject" ? (
                            <div className="py-2 pl-3">
                              <p>
                                <span className="font-weight-bold">Cán bộ VPCT, {eApprovedByITHead.split("|")[1]}</span>{" "}
                                đã từ chối với lý do: {e.value} ({e.date})
                              </p>
                            </div>
                          ) : (
                            <div className="py-2 pl-3">
                              <p>
                                <span className="font-weight-bold">Cán bộ VPCT, {eApprovedByITHead.split("|")[1]}</span>{" "}
                                đã phê duyệt, lưu ý: {e.value} ({e.date})
                              </p>
                            </div>
                          );
                        })}
                      {eAssigneeComment &&
                        eAssigneeCommentData.map((e: any) => {
                          return e.type === "reject" ? (
                            <div className="py-2 pl-3">
                              <p>
                                <span className="font-weight-bold">
                                  Bộ phận thực hiện cấp/hoàn vé VPCT, {eAssignee.split("|")[1]}
                                </span>{" "}
                                đã từ chối với lý do: {e.value} ({e.date})
                              </p>
                            </div>
                          ) : (
                            <div className="py-2 pl-3">
                              <p>
                                <span className="font-weight-bold">
                                  Bộ phận thực hiện cấp/hoàn vé VPCT, {eAssignee.split("|")[1]}
                                </span>{" "}
                                đã phê duyệt, lưu ý: {e.value} ({e.date})
                              </p>
                            </div>
                          );
                        })}
                      {approvalStep === approvalType && (
                        <div className="input">
                          <textarea
                            value={comment}
                            placeholder="Nhập lưu ý, lý do phê duyệt"
                            onChange={(e) => setComment(e.target.value)}
                          />
                        </div>
                      )}
                    </>
                  </div>
                  <td className="pb-1 pt-4 text-uppercase font-weight-bold">Thông tin trao đổi</td>
                  <div className="">
                    <CommentSection
                      comments={[]}
                      data={officialBusinessTicketRequest}
                      user={user}
                      id={7}
                      className="mb-4"
                    />
                  </div>
                </div>
                {approvalType === approverType.itlead && approvalStep === approvalType && (
                  <>
                    {/* {officialBusinessTicketRequest.fields.eDepartment !==
                        "Phòng Công nghệ thông tin" && (
                        <div className="InputWraper py-4">
                          <div className="mb-2">
                            Đơn vị quản lý chương trình
                          </div>
                          <div className="wraper">
                            <div className="people_picker-custom-detail">
                              <PeoplePicker
                                className="people-picker"
                                placeholder="Vui lòng chọn đơn vị quản lý chương trình"
                                type={PersonType.any}
                                // selectionChanged={onITHeadChange}
                              />
                            </div>
                          </div>
                        </div>
                      )} */}
                    <div className="InputWraper py-4">
                      <div className="mb-2">Bộ phận hành chính VPCT</div>
                      <div className="wraper">
                        <div className="people_picker-custom-detail">
                          <UserSelect
                            name="Chọn cán bộ VPCT"
                            onTouched={() => 1}
                            placeholder="Vui lòng chọn cán bộ VPCT"
                            options={eApprovalChangeOptions}
                            value={pickedItHead}
                            onChange={onApproverChange}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {checkApproval() && (
                  <>
                    {approvalStep === approvalType ? (
                      <div className="d-flex justify-content-center p-3">
                        <Button
                          className="mr10"
                          buttonType="success"
                          label={getButtonText()}
                          onClick={approveRequest}
                        />
                        <Button buttonType="grey" label="Không đồng ý" onClick={rejectRequest} className="mr10" />
                        <Button buttonType="danger" label="Hủy phiếu" onClick={cancelRequest} className="mr10" />

                        {currentUserName.toLowerCase() ===
                        officialBusinessTicketRequest.createdBy.user.email.toLowerCase() ? (
                          checkEdit() && (
                            <Button
                              className="mr5"
                              buttonType="warning"
                              label="Chỉnh sửa"
                              onClick={() =>
                                history.push(
                                  Routes.createProcedureCollaborateTicket.path.replace(
                                    ":id",
                                    officialBusinessTicketRequest.id,
                                  ),
                                )
                              }
                            />
                          )
                        ) : (
                          <></>
                        )}
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center p-3">
                        <Button buttonType="grey" label="Thu hồi" onClick={recoverRequest} />
                      </div>
                    )}
                  </>
                )}
              </Box>
            </div>
          </>
        );
      })()}
    </div>
  );
});
